import Siema from 'siema';
import MicroModal from 'micromodal';
import propertyFormSubmit from '../components/propertyFormSubmit';


function main() {
  const dots = document.querySelectorAll('.pagination-dot');
  // const propertyDescs = document.querySelectorAll('.property-gallery-desc');
  const propertySlides = document.querySelectorAll('.property-gallery-slide');

  if (propertySlides.length === 0) {
    return;
  }

  const bgSlider = new Siema({
    selector: '.property-gallery-container',
    duration: 600,
    easing: 'cubic-bezier(0.77, 0, 0.175, 1)',
    perPage: 1,
    startIndex: 0,
    draggable: false,
    threshold: 20,
    loop: true,
    rtl: false,
    onInit: () => {},
    onChange: () => {
      dots.forEach(d => d.classList.remove('is-active'));
      dots[bgSlider.currentSlide].classList.add('is-active');
      // propertyDescs.forEach(e => e.classList.remove('is-active'));
      // propertyDescs[bgSlider.currentSlide].classList.add('is-active');
    }
  });

  document
    .querySelector('.property-right-btn')
    .addEventListener('click', () => {
      bgSlider.next();
    });

  document.querySelector('.property-left-btn').addEventListener('click', () => {
    bgSlider.prev();
  });

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      bgSlider.goTo(index);
    });
  });

  dots[0].classList.add('is-active');
  // propertyDescs[0].classList.add('is-active');

  const getModal = document.querySelector('#phase-modal')
  if (getModal) {
    MicroModal.init();
    MicroModal.show('phase-modal'); 
  }

  propertyFormSubmit()
}

export default main;
